import {
  deleteDOCSignerTags,
  updateDocSignatoryActionV2,
} from "../../../actions/DocumentActions";
import store from "../../../store";
import DeleteDocComponentCommand from "../deleteComponentCommandBase/deleteDocComponentCommand";

class DeleteSignatureDocCommand extends DeleteDocComponentCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  execute() {
    const { signatoriesV2 = [], sectionID, docID } = this.componentData;
    super.execute();
    const deleteSignatureTagPayload = {
      component_id: sectionID,
      ids: [],
    };
    this.deletedTags = [];
    for (let i = 0; i < signatoriesV2.length; i += 1) {
      const { tags } = signatoriesV2[i];
      for (let j = 0; j < tags.length; j++) {
        const tag = tags[j];
        if (tag.component_id === sectionID) {
          deleteSignatureTagPayload.ids.push(tag.id);
          this.deletedTags.push(tag);
        }
      }
    }
    // make api/action call
    store.dispatch(deleteDOCSignerTags(docID, deleteSignatureTagPayload));
  }

  undo() {
    // add tag to signature
    const { docID } = this.componentData;
    store
      .dispatch(updateDocSignatoryActionV2(docID, this.deletedTags))
      .then(() => {
        this.deletedTags = [];
      });

    super.undo();
  }
}

export default DeleteSignatureDocCommand;
